<template>
  <!-- 客户案例 -->
  <div>
    <pageHeader :headerImg="config.headerImg" :headerTitle="config.headerTitle" :headerDesc="config.headerDesc">
    </pageHeader>

    <div class="banner">
      <div class="bannerTitle">{{ config.bannerTitle }}</div>
      <customer :source="'customer'"></customer>
    </div>
    <!-- 更多客户案例 -->
    <div class="content">
      <div class="content-title">{{ config.moreTitle }}</div>
      <div class="system-content">
        <div v-for="(system, systemIndex) in sortedMoreCase.slice((pageNum - 1) * pagesize, pageNum * pagesize)"
             :key="systemIndex" class="system-item">
          <div class="system-item-title" @click="pageToDetail(system)">{{ system.title }}</div>
          <div class="system-item-info">{{ system.info }}</div>
          <div>{{ system.date }}</div>
        </div>
      </div>
      <enoPagination :pageNum="pageNum" :pagesize="pagesize" :total="config.moreCase.length"
                     @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></enoPagination>
    </div>
  </div>
</template>

<script>
import {config} from './customer_case'
import pageHeader from '../common/page_header'
import enoPagination from '../common/eno_pagination'
import customer from '../home/components/customer'

export default {
  name: '',
  components: {pageHeader, enoPagination, customer},
  data() {
    return {
      config: config,
      pageNum: 1,
      pagesize: 10,

    };
  },
  computed: {
    sortedMoreCase() {
      return this.sortCaseByDate(this.config.moreCase)
    }
  },
  watch: {},
  methods: {
    sortCaseByDate(list) {
      const arr = JSON.parse(JSON.stringify(list))
      return arr.sort((a, b) => new Date(b.date) - new Date(a.date))
    },
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.pageNum = val
    },
    pageToDetail(item) {
      this.$router.push({
        path: '/news_information_detail',
        query: {fileName: item.fileName, title: item.title, date: item.date, source: '客户案例',}
      })
    },
  },
};
</script>

<style scoped lang="less">
.banner {
  margin: 110px 68px 60px;

  .bannerTitle {
    font-size: 40px;
  }
}

.content {
  margin: 150px 68px 60px;

  .content-title {
    font-size: 40px;
    margin-bottom: 60px;
  }

  .system-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 24px;

    .system-item {
      padding: 30px 0px;
      border-top: 1px solid @mainGrayColor3;

      &:nth-last-child(2),
      &:last-child {
        border-bottom: 1px solid @mainGrayColor3;
      }

      .system-item-title {
        font-size: 20px;
        position: relative;
        width: fit-content;
        cursor: pointer;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        height: 60px;

        &:hover {
          border-bottom: 1px solid @black;
        }
      }

      .system-item-info {
        font-size: 16px;
        color: @mainGrayColor2;
        line-height: 32px;
        margin: 8px 0 20px;

        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.footer {
  /*   display: flex;
  justify-content: center;
  align-items: center; */
  position: relative;
  background-color: #FFF100;
  height: 323px;
  line-height: 323px;
  width: 100%;
  color: #000000;
  text-align: center;

  &-text {
    font-size: 40px;
    position: absolute;
    top: 98px;
    left: 50%;
    transform: translate(-50%, -50%);
    /*  display: flex;
    justify-content: center;
    align-items: center; */
    height: 40px;
    line-height: 40px;
  }

  &-btn {
    position: absolute;
    top: 178px;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: OPPOSans;
    font-weight: 400;
    width: 153px;
    height: 57px;
    line-height: 57px;
    font-size: 20px;
    border: 1px #000000 solid;

    text-align: center;

    &:hover {
      cursor: pointer;
      font-size: 21px;
    }
  }
}

@media @mobile {
  .banner {
    margin: -50px 16px 0 16px;
    /*  display: flex;
    justify-content: center;
    align-items: center; */

    .bannerTitle {
      display: none;
    }
  }

  .content {
    margin: 60px 16px 40px;

    .content-title {
      font-size: 24px;
      margin-bottom: 30px;
      line-height: 1.3;
    }

    .system-content {
      display: grid;
      grid-template-columns: 1fr;
      grid-column-gap: 0;

      .system-item {
        padding: 20px 0;

        .system-item-title {
          font-size: 18px;
          height: auto;
          line-height: 1.4;
          -webkit-line-clamp: 2;
          height: 52px;
        }

        .system-item-info {
          font-size: 14px;
          line-height: 24px;
          margin: 6px 0 16px;
          -webkit-line-clamp: 2;
        }

        div:last-child {
          font-size: 14px;
          color: @mainGrayColor2;
        }
      }
    }
  }

  .footer {
    height: 200px;
    line-height: 200px;

    &-text {
      font-size: 24px;
      top: 70px;
      height: auto;
      line-height: 1.3;
      white-space: nowrap;
    }

    &-btn {
      top: 130px;
      width: 120px;
      height: 44px;
      line-height: 44px;
      font-size: 16px;

      &:hover {
        font-size: 17px;
      }
    }
  }
}
</style>
